/**
 * @flow
 */

import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { filter, find, map, get } from 'lodash';

import { Select } from 'semantic-ui-react';
import { addInvoiceProduct } from '../../../../../actions/invoice';

export const GET_CART_PRODUCTS_QUERY = gql`
    query getTitles($salon: ID!) {
        viewer {
            id
            ... on Administrator {
                salon(id: $salon) {
                    id
                    products {
                        nodes {
                            id
                            name
                            price
                            quantity
                        }
                    }
                }
            }
        }
    }
`;

function ProductSelect({ value, onChange, paid, change, name, ...rest }) {
    const salon = useSelector(({ user }) => user.get('salon'));
    const dispatch = useDispatch();

    const { data, loading } = useQuery(GET_CART_PRODUCTS_QUERY, {
        variables: { salon },
        fetchPolicy: 'cache-and-network',
        skip: !salon,
    });

    const products =
        !loading && data && data.viewer
            ? filter(
                  get(data, 'viewer.salon.products.nodes', []),
                  item => item.quantity > 0,
              )
            : [];

    const options = map(products, item => ({
        key: item.id,
        text: item.name,
        value: item.id,
        description: item.quantity,
    }));

    const handleChange = (e, { value: v }) => {
        const product = find(products, { id: v });
        const namePrefix = name.replace('entity', '');
        if (product) {
            change(namePrefix + 'price', product.price.toFixed(2));
            change(namePrefix + 'quantity', 1);
            change(namePrefix + 'paymentType', 'CASH');
            dispatch(addInvoiceProduct(name, product));
        }
        onChange(e, { value: v });
    };

    return (
        <Select
            value={value}
            onChange={handleChange}
            options={options}
            loading={loading}
            {...rest}
        />
    );
}

export default ProductSelect;
